import BaseComponent from "../../../../baseComponent.js";
import InternalEvent from "../../../../../core/constants/internalEvent.js";
import WidgetService from "../../../../../core/services/widgetService.js";
import styles from "./tooltip.scss";
import Widget from "../../../../../core/models/widget";

class Range extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    let secondLabel = [], colSpan = 0, classes = "";
    if (this.props.secondLabel.length > 0) {
      secondLabel.push(<td style={{paddingLeft: "10px", textAlign: "right"}} key="0">{this.props.secondLabel}</td>);
      secondLabel.push(<td key="1">
        <div className={styles.legendColor}
             style={{background: this.props.color, margin: "0 0 0 8px"}}/>
      </td>);
    } else {
      colSpan = 3;
      classes = " tooltip-range--single";
    }
    return (
      <tr className={"tooltip-line" + classes}>
        <td>
          <div className={styles.legendColor} style={{background: this.props.color}}/>
        </td>
        <td>{this.props.firstLabel}</td>
        <td style={{display: "flex"}} className="tooltip-line__values" colSpan={colSpan}>
          <div id={this.props.firstLegendId} className="tooltip-line__value"/>
          <div style={{padding: "0 4px"}}>-</div>
          <div id={this.props.secondLegendId} className="tooltip-line__value"/>
        </td>
        {
          this.props.showDifference === false ? null :
            <td>
              <div className="tooltip-line__value" style={{textAlign: "right", paddingLeft: "5px"}}/>
            </td>
        }
        {secondLabel}
      </tr>
    )
  }
}

class Line extends BaseComponent {

  render() {

    return (
      <tr className={"tooltip-line"}>
        <td>
          <div className={styles.legendColor} style={{background: this.props.color}}></div>
        </td>
        <td>{this.props.label}</td>
        <td colSpan="3">
          <div id={this.props.id} className={"tooltip-line__values"}></div>
        </td>
      </tr>
    )
  }
}

class Bubble extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
      volume: null,
      tailPoint: null
    }
  }

  componentDidMount() {
    this.subscribe('show-event-bubble-tooltip', data => {
      if (this.props.widgetId === data.widgetId && this.props.id == data.legendId) {
        const dateElement = $(`#${this.props.toolTipContainerId}-date`);
        const widget = WidgetService.getWidget(this.props.widgetId);
        const timeStr = Widget.getFormattedDateTimeString(widget.metaData, data.timestamp, true);
        this.update(data);
        this.originalDate = dateElement.text();
        dateElement.text(timeStr);
      }
    });

    this.subscribe('clear-event-bubble-tooltip', data => {
      if (this.props.widgetId === data.widgetId && this.props.id == data.legendId) {
        const dateElement = $(`#${this.props.toolTipContainerId}-date`);
        this.update();
        dateElement.text(this.originalDate);
        this.originalDate = '';
      }
    });
  }

  componentWillUnmount() {
    this.unsubscribeAll();
  }

  update(data = {}) {
    const {y, size, tailPoint} = data;
    this.setState({
      value: y,
      volume: size,
      tailPoint
    });
  }

  render() {
    const style = {
      display: this.state.value != null ? 'table-row' : 'none',
      lineHeight: '16px'
    };
    return (
      <tr ref="tooltipLine" className={"tooltip-line"} style={style}>
        <td>
          <div className={styles.legendColor} style={{background: this.props.color}}/>
        </td>
        <td>
          <div>{this.props.label}</div>
          <div>Volume</div>
          {
            this.state.tailPoint != null ?
              <div ref="tailPointLabel">Tail Point</div> : null
          }
        </td>
        <td colSpan="3">
          <div className="tooltip-line__values">{this.state.value}</div>
          <div className="tooltip-line__values">{this.state.volume}</div>
          {
            this.state.tailPoint != null ?
              <div className="tooltip-line__values">
                {`${this.state.tailPoint} (${Math.abs(this.state.value - this.state.tailPoint).toFixed(5)})`}
              </div> : null
          }
        </td>
      </tr>
    )
  }
}


export default class Tooltip extends BaseComponent {
  constructor(props) {
    super(props);
    this.widget = WidgetService.getWidget(this.props.widgetId);
    this.legends = this.widget.legends;
    this.toolTipContainerId = this.props.widgetId + "_tooltip-container";
    this.state = {status: null};
  }

  componentDidMount() {
    this.subscribe(InternalEvent.Dashboard.UPDATE_TOOLTIP, payload => this.update(payload));
    this.subscribe(InternalEvent.Dashboard.HIDE_TOOLTIP, payload => this.hide(payload));
    this.subscribe(InternalEvent.Dashboard.CHART_LEGEND_UPDATED, this.handleLegendUpdate);
  }

  handleLegendUpdate() {
    const widget = WidgetService.getWidget(this.props.widgetId);
    if (widget) {
      this.legends = widget.legends;
      this.forceUpdate();
    }
  }

  componentWillUnmount() {
    this.unsubscribeAll();
  }

  update(payload) {
    if (payload.widgetId !== this.props.widgetId) return;

    const widget = WidgetService.getWidget(this.props.widgetId);
    let timestamp;
    let timestampUpdate = false;
    for (var i = 0; i < this.legends.length; i++) {
      if (this.legends[i].parameters.isActive || this.legends[i].parameters.isActive == null) {
        var valueElement = $("#tooltip-" + this.props.widgetId).find("#" + this.legends[i].id);
        var data = getDataAtIndexByDatasetId(this.legends[i].id);

        if (data != null && !isNaN(data.y)) {
          var value = data.y;

          if (data.time != null) timestamp = data.time * 1000;

          for (let key in data) {
            if (data.time && data[key] && data[key].timestamp) {
              if (data[key].isMyDatasetUpdate) {
                if (parseInt(data[key].timestamp / 1000) === data.time) {
                  timestamp = data[key].timestamp;
                  const timeStr = Widget.getFormattedDateTimeString(widget.metaData, timestamp, true);
                  $(this.refs.date).text(timeStr);
                  timestampUpdate = true;
                }
              } else {
                if (timestamp == null || timestamp < data[key].timestamp) {
                  timestamp = data[key].timestamp;
                }
              }
            }
          }

          if (value != null) value = parseFloat(value.toFixed(7));
          valueElement.text(value);

          if (this.legends[i].parameters.chartType === "bubble") {
            const bubbleComponent = this.refs[this.props.widgetId + this.legends[i].id];
            const resolution = widget.metaData.resolution;
            // bubbles are rendered differently on resolution mode
            if (!resolution || resolution[0] === 'tick') {
              bubbleComponent.update(data);
            }
          }

          this.checkReverseValueOrder();
          $(".tooltip-line__values").css("color", payload.color);
          if (!timestampUpdate) {
            const timeStr = Widget.getFormattedDateTimeString(widget.metaData, timestamp, true);
            $(this.refs.date).text(timeStr);
          }
        } else {
          valueElement.text("");
          if (!timestampUpdate && data && data.time) {
            const timeStr = Widget.getFormattedDateTimeString(widget.metaData, data.time * 1000, true);
            $(this.refs.date).text(timeStr);
          }
        }
      }
    }
    if (payload.event) {
      this.setPosition(payload.event);
    }

    function getDataAtIndexByDatasetId(legendId) {
      for (let i = 0; i < payload.data.length; i++) {
        if (payload.data[i] != null &&
          payload.data[i][payload.index] != null &&
          payload.data[i][payload.index].legendId == legendId) {
          return payload.data[i][payload.index];
        }
      }
      return null;
    }
  }

  checkReverseValueOrder() {
    var rangeTooltipLines = $("#tooltip-" + this.props.widgetId).find(".tooltip-range--single");
    for (var i = 0; i < rangeTooltipLines.length; i++) {
      var line = $(rangeTooltipLines[i]);
      if (line.children().length === 4) {
        var valueElements = line.find(".tooltip-line__value");
        var value1 = parseFloat($(valueElements[0]).text());
        var value2 = parseFloat($(valueElements[1]).text());

        // todo: temporary showing negative value for FXall demo
        // const diff = parseFloat(Math.abs(value1 - value2).toFixed(5));
        const diff = parseFloat((value2 - value1).toFixed(5));

        if (!isNaN(diff)) {
          $(valueElements[2]).text(`(${diff})`);

          // todo: temporary disabled for FXall demo
          // if (value1 > value2) {
          //   line.find(".tooltip-line__values").addClass("tooltip-line__values--reverse");
          // } else {
          //   line.find(".tooltip-line__values").removeClass("tooltip-line__values--reverse");
          // }
        }
      }
    }
  }

  setPosition(event) {
    let status = "block";
    var windowWidth = $(window).width();
    var tooltipContainer = $("#" + this.toolTipContainerId);
    var tooltipWidth = tooltipContainer.width();
    var left = event.clientX + 50;

    if (this.state.status == "tooltip-off") {
      status = "none";
    }

    if (left + tooltipWidth + 30 >= windowWidth) left = event.clientX - 50 - tooltipWidth;
    tooltipContainer.css({
      display: status,
      left: left,
      top: event.pageY - (tooltipContainer.height() / 2) + 25
    });
  }

  hide(payload) {
    if (payload.widgetId === this.props.widgetId) {
      $("#" + this.toolTipContainerId).hide();
    }
  }

  shouldHideTooltip(parameters) {
    return (this.props.metaData.yAxisVisibility === "right" && parameters.yAxisSide === 'left') ||
      (this.props.metaData.yAxisVisibility === "left" && parameters.yAxisSide === 'right') ||
      parameters.tooltipVisible === false
  }

  render() {
    var legends = {}, singleLegends = [], tooltips = [];

    for (var i = 0; i < this.legends.length; i++) {
      if (this.legends[i].parameters.isActive) {
        var groupId = this.legends[i].parameters.groupId;
        if (legends[groupId]) {
          legends[groupId].push(this.legends[i]);
        } else {
          legends[groupId] = [this.legends[i]];
        }
      }
    }

    for (var groupId in legends) {
      if (!this.shouldHideTooltip(legends[groupId][0].parameters)) {
        if (legends[groupId].length === 2) {
          tooltips.push(<Range
            firstLegendId={legends[groupId][0].id}
            secondLegendId={legends[groupId][1].id}
            firstLabel={legends[groupId][0].parameters.legendLabel}
            secondLabel={legends[groupId][1].parameters.legendLabel}
            color={legends[groupId][0].parameters.legendColor}
            showDifference={legends[groupId][0].parameters.showDifference}
            active={legends[groupId][0].parameters.isActive || true} key={groupId}/>);
        } else {
          if (legends[groupId][0].parameters.chartType === "bubble") {
            tooltips.push(<Bubble
              id={legends[groupId][0].id}
              widgetId={this.props.widgetId}
              toolTipContainerId={this.toolTipContainerId}
              label={legends[groupId][0].parameters.legendLabel}
              color={legends[groupId][0].parameters.legendColor}
              active={legends[groupId][0].parameters.isActive || true}
              ref={this.props.widgetId + legends[groupId][0].id}
              key={groupId}/>);
          } else {
            // hide hidden legend tooltip
            tooltips.push(<Line
              id={legends[groupId][0].id}
              label={legends[groupId][0].parameters.legendLabel}
              color={legends[groupId][0].parameters.legendColor}
              active={legends[groupId][0].parameters.isActive || true} key={groupId}/>);
          }
        }
      }

    }

    return (
      <div className={styles.tooltip} id={this.toolTipContainerId}>
        <table>
          <tbody>
          {tooltips}
          </tbody>
        </table>
        <div className="tooltip-line__values tooltip-date" id={this.toolTipContainerId + '-date'} ref="date"></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/timeseries-chart/tooltip/tooltip.jsx